import { render, staticRenderFns } from "./KnowledgeBaseCategoryQuestion.vue?vue&type=template&id=27a14bca&"
import script from "./KnowledgeBaseCategoryQuestion.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseCategoryQuestion.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseCategoryQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports